import E7Icon from "../../assets/product-list-assets/wifi-e7.svg";
import type { ProductListGroup } from "../../types";

export const wifiE7: ProductListGroup = {
  id: "wifiE7",
  title: "productListGroup.wifiEnterprise7.title",
  seriesLabel: "modelCompare.seriesLabel.wifiE7",
  icon: {
    src: E7Icon,
    width: 24,
    height: 21,
  },
  isSpotlightGroup: true,
};
